// Utility functions specific to the referto tablet interface

// Check if a specific stat element is marked (clicked)
export const isStatElementMarked = (refertoData, team, section, playerIdP, column) => {
  if (!refertoData || !refertoData[team] || !refertoData[team][section]) {
    return false;
  }
  const key = `${playerIdP}_${column}`;
  return refertoData[team][section][key] === '1';
};

// Check if a team stat is marked
export const isTeamStatMarked = (refertoData, team, section, index) => {
  if (!refertoData || !refertoData[team] || !refertoData[team][section]) {
    return false;
  }
  return refertoData[team][section][index] === '1';
};

// Get CSS class for marked/unmarked elements
export const getStatElementClass = (refertoData, team, section, playerIdP, column, baseClass = 'referto-tablet-grid-input') => {
  const isMarked = isStatElementMarked(refertoData, team, section, playerIdP, column);
  return `${baseClass} ${isMarked ? 'referto-marked' : ''}`;
};

// Get CSS class for team stat elements
export const getTeamStatClass = (refertoData, team, section, index, baseClass = 'referto-tablet-grid-input referto-tablet-small') => {
  const isMarked = isTeamStatMarked(refertoData, team, section, index);
  return `${baseClass} ${isMarked ? 'referto-marked' : ''}`;
};

// Calculate totals for a player's statistics
export const calculatePlayerStatTotal = (refertoData, team, section, playerIdP) => {
  if (!refertoData || !refertoData[team] || !refertoData[team][section]) {
    return 0;
  }
  const playerStats = Object.keys(refertoData[team][section])
    .filter(key => key.startsWith(`${playerIdP}_`) && refertoData[team][section][key] === '1');
  
  return playerStats.length;
};

// Calculate team totals for a specific statistic
export const calculateTeamStatTotal = (refertoData, team, section) => {
  if (!refertoData || !refertoData[team] || !refertoData[team][section]) {
    return 0;
  }
  const teamStats = Object.keys(refertoData[team][section])
    .filter(key => refertoData[team][section][key] === '1');
  
  return teamStats.length;
};

// Calculate all statistics for a team
export const calculateTeamTotals = (refertoData, team, giocatori) => {
  const totals = {
    mete: 0,
    scalpiBuoni: 0,
    scalpiVuoti: 0,
    assist: 0,
    vuotiSquadra: 0,
    falliSquadra: 0
  };

  // Calculate player statistics
  giocatori.forEach((giocatore) => {
    totals.mete += calculatePlayerStatTotal(refertoData, team, 'mete', giocatore.idP);
    totals.scalpiBuoni += calculatePlayerStatTotal(refertoData, team, 'scalpiBuoni', giocatore.idP);
    // Sum all scalpi vuoti from separate sections
    totals.scalpiVuoti += calculatePlayerStatTotal(refertoData, team, 'scalpi1', giocatore.idP);
    totals.scalpiVuoti += calculatePlayerStatTotal(refertoData, team, 'scalpi2', giocatore.idP);
    totals.scalpiVuoti += calculatePlayerStatTotal(refertoData, team, 'scalpi3', giocatore.idP);
    totals.assist += calculatePlayerStatTotal(refertoData, team, 'assist', giocatore.idP);
  });

  // Calculate team statistics
  totals.vuotiSquadra = calculateTeamStatTotal(refertoData, team, 'vuotiSquadra');
  totals.falliSquadra = calculateTeamStatTotal(refertoData, team, 'falliSquadra');

  // Add one meta for every 3 team fouls
  const bonusMete = Math.floor(totals.falliSquadra / 3);
  totals.mete += bonusMete;

  return totals;
};

// Validate referto data completeness
export const validateRefertoData = (refertoData, squadraA, squadraB) => {
  const errors = [];

  if (!squadraA) {
    errors.push('Squadra A non definita');
  }

  if (!squadraB) {
    errors.push('Squadra B non definita');
  }

  // Check if at least some statistics are filled
  const totalsA = squadraA ? calculateTeamTotals(refertoData, 'squadraA', squadraA.giocatori || []) : null;
  const totalsB = squadraB ? calculateTeamTotals(refertoData, 'squadraB', squadraB.giocatori || []) : null;

  const hasAnyStats = (totalsA && (totalsA.mete > 0 || totalsA.scalpiBuoni > 0 || totalsA.scalpiVuoti > 0 || totalsA.assist > 0 || totalsA.falliSquadra > 0)) ||
                      (totalsB && (totalsB.mete > 0 || totalsB.scalpiBuoni > 0 || totalsB.scalpiVuoti > 0 || totalsB.assist > 0 || totalsB.falliSquadra > 0));

  if (!hasAnyStats) {
    errors.push('Nessuna statistica inserita');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// Export all utilities for easy import
export const refertoUtils = {
  isStatElementMarked,
  isTeamStatMarked,
  getStatElementClass,
  getTeamStatClass,
  calculatePlayerStatTotal,
  calculateTeamStatTotal,
  calculateTeamTotals,
  validateRefertoData
};